import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  leftBannerImgurl = 'assets/images/forgot-password-banner.png';
  IsValidated = false;
  HasWhatsapp = false;
  EmailMode = false;
  GroupId;
  PasswordHash = '';
  WhatsAppMode = false;
  UserEmail: string = '';
  WhatsAppNo: string = '';
  ForgotPassword!: FormGroup;
  returnUrl!: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toaster: ToastrService,
    private formBuilder: FormBuilder,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.ForgotPassword = this.formBuilder.group({
      username: ['', [Validators.required]],
      type: ['', [Validators.required]],
    });
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  onSubmit(): void {

    // stop here if form is invalid
    if (this.ForgotPassword.invalid) {
      return;
    }
    if (this.ForgotPassword.value.type == "" || this.ForgotPassword.value.type == 1) {
      const key = {
        email: this.UserEmail,
        passwordHash: this.PasswordHash,
        username: this.ForgotPassword.value.username,
        url: document.location.origin
      }
      this.authService.ForgotPasswordEmail(key).subscribe((res: any) => {
        if (res) {
          this.toaster.success('Your password is sent to your email address.');
          this.router.navigate(['/login']);
        }
        else {
          this.toaster.error('Error', "Something wend wrong.");
        }
      },
        (error) => {
          this.toaster.error('Error', error.error.message);
        }
      );

    }
    else {
      const key = {
        WhatsAppNo: this.WhatsAppNo,
        passwordHash: this.PasswordHash,
        groupId: this.GroupId
      }
      this.authService.ForgotPasswordWhatsApp(key).subscribe((res: any) => {

        this.toaster.success('Your password is sent to your WhatsApp.');
        this.router.navigate(['/login']);
      },
        (error) => {
          this.toaster.error('Error', error.error.message);
        }
      );

    }


  }


  ValidateUserName(): any {
    const key = {
      username: this.ForgotPassword.value.username
    };
    this.authService.ValidateUserName(key).subscribe((res: any) => {

      if (res[0].Email) {
        this.IsValidated = true
        this.PasswordHash = res[0].Password;
        this.UserEmail = res[0].Email;
        this.EmailMode = true;
        this.GroupId = res[0].groupId;
        this.WhatsAppMode = false;
        this.ForgotPassword.get("type").setValue(1);
        if (res[0].Mobile) {
          this.HasWhatsapp = true;
          this.WhatsAppNo = res[0].Mobile;
        }
        else {
          this.HasWhatsapp = false;

        }

      }
      else {
        this.IsValidated = false;
        this.toaster.error('Error', 'User Not Found');
        this.EmailMode = false;
        this.WhatsAppMode = false;
        this.ForgotPassword.get("type").setValue(null);
      }



    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );

  }


  changeMode(event: any): void {




    if (event.value == 1) {
      this.EmailMode = true;
      this.WhatsAppMode = false;
    }
    else if (event.value == 2) {
      this.EmailMode = false;
      this.WhatsAppMode = true;
    }

  }
}
